<!-- src/app/app.component.html -->
<div class="app-container">
  <app-header></app-header>
  <main>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </main>
</div>
